import React, { useState } from "react";
import { Grid, Modal, Box } from "@mui/material";
import { Icon } from "@iconify/react";
import IconButton from "@mui/material/IconButton";
import { AntSwitch } from "../../../components/antSwitch";
import { useNavigate } from "react-router-dom";
import DeleteModal from "./deleteModal";
import StatusModal from "./statusModal";
import { Chip, Tooltip, Typography } from '@mui/material';

export default function SubscriptionPlansColumn(props) {
    const { setAlert, setOpenAlert, setResponseMsg, setLoading, getSubscriptionData } = props;
    const navigate = useNavigate();
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openStatusModal, setOpenStatusModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const ALERT_DURATION = 2000;

    const alertClose = () => {
        setAlert('')
    }
    const handleOpenDeleteModal = (id, status) => {
        setSelectedId(id);
        setSelectedStatus(status);
        setOpenDeleteModal(true);
    };

    const handleOpenStatusModal = (id, status) => {
        setSelectedId(id);
        setSelectedStatus(status);
        setOpenStatusModal(true);
    };

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false);
    };

    const handleCloseStatusModal = () => {
        setOpenStatusModal(false);
    };

    const subscriptionPlansColumn = [
        // {
        //     field: 'id',
        //     headerName: 'ID',
        // },
        {
            field: 'planName',
            headerName: 'Plan Name',
            flex: 1,
            renderCell: (params) => {
                return (
                    <Grid onClick={() => navigate(`/subscriptionView/${params.row.id}?type=edit`)}>
                        <span style={{ color: "darkblue", cursor: 'pointer' }}>  {params.value}  </span>
                    </Grid>
                );
            },
        },
        {
            field: 'description',
            headerName: 'Description',
            flex: 1.5,
            renderCell: (params) => {
                const htmlString = params.value || "";
                const plainText = htmlString.replace(/<[^>]+>/g, '').replace(/\n/g, ' ');
                return (
                    <div>
                        {plainText}
                    </div>
                );
            },
        },
        {
            field: 'setupFee',
            headerName: 'Setup Fee',
            flex: 0.8,
            renderCell: (params) => {
                return (
                    <Grid>
                        <span>{`$ ${params.value}`}</span>
                    </Grid>
                );
            },
        },
        {
            field: 'subscriptionFee',
            headerName: 'Monthly Fee',
            flex: 0.8,
            renderCell: (params) => {
                return (
                    <Grid>
                        <span>{`$ ${params.value}`}</span>
                    </Grid>
                );
            },
        },
        {
            field: 'userTypes',
            headerName: 'User Types',
            flex: 1,
            renderCell: (params) => {
                const userTypes = params.row.userTypes;

                if (!userTypes || userTypes.length === 0) {
                    return <Typography>-</Typography>;
                }

                const firstType = userTypes[0];
                const remainingTypes = userTypes.slice(1);

                const tooltipContent = (
                    <Box display="flex" flexWrap="wrap" gap={1}>
                        {remainingTypes.map((type, index) => (
                            <Chip
                                key={index}
                                label={type.typeName}
                                variant="outlined"
                                sx={{
                                    borderColor: 'var(--primary-color',
                                    color: 'var(--primary-color',
                                    backgroundColor: 'var(--white-color)',
                                    fontWeight: 900,
                                    borderRadius: '16px',
                                    height: 32,
                                }}
                            />
                        ))}
                    </Box>
                );

                return (
                    <Box display="flex" gap={1} alignItems="center" style={{ paddingTop: 10 }}>
                        <Chip
                            label={firstType.typeName}
                            variant="outlined"
                            sx={{
                                borderColor: 'var(--primary-color',
                                color: 'var(--primary-color',
                                backgroundColor: 'var(--white-color)',
                                fontWeight: 900,
                                borderRadius: '16px',
                                height: 32,
                            }}
                        />
                        {remainingTypes.length > 0 && (
                            <Tooltip title={tooltipContent} placement="top-start" arrow>
                                <Typography
                                    sx={{
                                        fontSize: 14,
                                        color: ' var(--primary-color)',
                                        cursor: 'pointer',
                                        textDecoration: 'underline dotted',
                                    }}
                                >
                                    +{remainingTypes.length} more
                                </Typography>
                            </Tooltip>
                        )}
                    </Box>
                );
            },
        },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
            renderCell: (params) => (
                <>
                    <Grid style={{ paddingTop: 15 }}>
                        <AntSwitch checked={params.row.status === "ACTIVE"} onChange={() => handleOpenStatusModal(params.row.id, params.row.status)} inputProps={{ "aria-label": "controlled" }} />
                    </Grid>

                    <Modal open={openStatusModal} onClose={handleCloseStatusModal} BackdropProps={{ sx: { backgroundColor: "rgba(0, 0, 0, 0.1)" } }}>
                        <StatusModal onClose={handleCloseStatusModal} getSubscriptionData={getSubscriptionData} selectedId={selectedId} selectedStatus={selectedStatus} alertClose={alertClose} setOpenAlert={setOpenAlert} setResponseMsg={setResponseMsg} setAlert={setAlert} ALERT_DURATION={ALERT_DURATION} setLoading={setLoading} />
                    </Modal>
                </>
            ),
        },
        {
            field: "actions",
            headerName: "Actions",
            flex: 1,
            renderCell: (params) => (
                <>
                    <Grid>
                        <IconButton aria-label="edit" size="small">
                            <img src="/assets/editIcon.svg" alt="District" width="16" height="16" onClick={() => navigate(`/addSubcriptions/${params.row.id}?type=edit`)} />
                        </IconButton>

                        <IconButton aria-label="delete" size="small" onClick={() => handleOpenDeleteModal(params.row.id, params.row.status)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="red" d="M7.5 1h9v3H22v2h-2.029l-.5 17H4.529l-.5-17H2V4h5.5zm2 3h5V3h-5zM6.03 6l.441 15h11.058l.441-15zM13 8v11h-2V8z" /></svg>
                        </IconButton>
                    </Grid>

                    <Modal open={openDeleteModal} onClose={handleCloseDeleteModal} BackdropProps={{ sx: { backgroundColor: "rgba(0, 0, 0, 0.1)" } }}>
                        <DeleteModal onClose={handleCloseDeleteModal} getSubscriptionData={getSubscriptionData} selectedId={selectedId} selectedStatus={selectedStatus} alertClose={alertClose} setOpenAlert={setOpenAlert} setResponseMsg={setResponseMsg} setAlert={setAlert} ALERT_DURATION={ALERT_DURATION} setLoading={setLoading} />
                    </Modal>
                </>
            ),
        },

    ];

    return subscriptionPlansColumn;
}


